import React from 'react';

import HeadWrapper from 'app/shared/components/HeadWrapper';
import { ErrorPage } from '@zillow/zrs-zillow-offers';

import { StyledPage } from './StyledComponents';

const NotFoundPage = () => (
    <StyledPage noPadding={true} className="NotFoundPage">
        <HeadWrapper title="Page not found" />
        <ErrorPage
            homePageText="Return to Zillow Rental Manager"
            homePageUrl="https://www.zillow.com/rental-manager"
        />
    </StyledPage>
);

export default NotFoundPage;
